import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/seo/JsonLd";
import { Avaliacao360, faq } from "@/components/itv/pages/Avaliacao360";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import {
  breadcrumbSchema,
  faqSchema,
  medicalWebPageSchema,
  type Trilha,
} from "@/lib/schema";

const PATH = "/tratamentos/avaliacao-360/";
const TITLE = "Avaliação 360: Consulta Nutrológica | Dr. Thiago Viana";
const DESCRIPTION =
  "A Avaliação 360 integra história clínica, composição corporal por bioimpedância e exames laboratoriais em um plano médico exclusivo para o seu caso.";

export const Route = createFileRoute("/tratamentos/avaliacao-360")({
  loader: async () => {
    return carregarPaginaSimples(PATH, TITLE, DESCRIPTION);
  },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  const trilha: Trilha[] = [
    { nome: "Home", path: "/" },
    { nome: "Tratamentos", path: "/tratamentos/" },
    { nome: "Avaliação 360", path: PATH },
  ];

  return (
    <>
      <Avaliacao360 />
      <JsonLd data={medicalWebPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION })} />
      <JsonLd data={breadcrumbSchema(trilha)} />
      <JsonLd data={faqSchema(faq)} />
    </>
  );
}
